import queryString from 'query-string';
import { decode } from 'html-entities/lib/html4-entities';
import API from 'shared/constants/api';
import { getAdsContext } from 'shared/helpers/adsAndMetrics';
import { setJournalNews } from 'shared/actions/journal';
import { buildJournalListingUrl } from '../../../helpers/urlBuilder';
import { stripHTML } from '../../../helpers/strings';

const TEST_DRIVE_RUBRIC_SLUG = 'test-drive';
const PER_PAGE = 10;

const fetchRelatedAdverts = (fetch, { agency, make, model, generation, year }) =>
  fetch(
    API.ADVERT.ALL(
      `?${queryString.stringify({
        make: make || undefined,
        model: model || undefined,
        generation: generation || undefined,
        year: year || undefined,
        dealer: agency || null, // to only include adverts by the agency that submitted the post
        per_page: 6,
      })}`,
    ),
  )
    .then(r => r.json())
    .then(r => r.results)
    .catch(() => undefined);

async function action(
  { fetch, params, query, store, baseUrl },
  { shouldFetchRelatedAdverts = true } = {},
) {
  const { id } = params;
  if (!id) {
    return null;
  }

  const newsResponse = await fetch(API.JOURNAL.ITEM(id));

  if (!newsResponse.ok) {
    return null;
  }

  const results = await newsResponse.json();
  const post = Array.isArray(results) && results[0];

  if (!post) {
    return null;
  }

  const relatedAdverts =
    shouldFetchRelatedAdverts && post.rubric.slug === TEST_DRIVE_RUBRIC_SLUG
      ? await fetchRelatedAdverts(fetch, {
          agency: post.agency && post.agency.id,
          make: post.make && post.make.id,
          model: post.model && post.model.id,
          generation: post.generation && post.generation.id,
          year: post.year,
        })
      : undefined;

  const tag = post.tags.find(t => t.slug === query.tag);
  const currentRubric = post.rubric;

  const { locale, location, journal } = store.getState().globals;
  const { rubrics } = journal;
  const joinedTags = [currentRubric, ...post.tags].map(t => t.slug).join(' ');
  const targetingArguments = getAdsContext({
    rubric: { slug: joinedTags },
    page: baseUrl.replace(/\//g, ''),
    location,
  });

  const newsListResponse = await fetch(
    API.JOURNAL.LIST({
      tag,
      page: 1,
      perPage: PER_PAGE,
      rubric: ['news'],
      language: locale,
    }),
  );
  let news = [];

  if (newsListResponse.status !== 404) {
    const newsData = await newsListResponse.json();
    news = newsData.results;
  }
  store.dispatch(setJournalNews(news));

  const breadcrumbs = [
    {
      title: currentRubric.title,
      link: buildJournalListingUrl(rubrics, currentRubric),
    },
    tag &&
    tag.slug && {
      title: tag.title,
      link: buildJournalListingUrl(rubrics, currentRubric, tag.slug),
    },
  ].filter(x => x);

  const key = locale === 'ru' ? '' : `_${locale}`;

  let title = post[`seo_title${key}`];
  let description = post[`search_description${key}`];

  if (!title) {
    const postSeoTitle =
      locale === 'ru' ? post.title || post.title_uk : post.title_uk || post.title;
    title = `${postSeoTitle} – Автобазар`;
  }
  if (!description) {
    const postSeoDescription =
      locale === 'ru' ? post.content || post.content_uk : post.content_uk || post.content;
    const decodedText = decode(stripHTML(postSeoDescription));
    description = decodedText.substr(0, 227).replace('\n', '').trim();
  }

  return {
    title,
    description,
    ogImage: post && post.image && post.image.url ? post.image.url : undefined,
    post,
    id,
    tag,
    targetingArguments,
    relatedAdverts,
    breadcrumbs,
    query,
    news,
    currentRubric,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/shared/routes/journal/news-page/index.js